<template>
  <div class="row">
    <div class="col-lg-6 box">
      <span>Evento:</span>
      <el-select v-model="eventId" @change="$emit('eventSelected', eventId)" name="eventId" class="select-primary el-select item" size="large" placeholder="Selecione um evento">
        <!-- <el-option value=""> Selecione um evento...</el-option> -->
        <el-option v-for="(event, index) in events" class="select-primary" :key="index" :label="event.label" :value="event.value" />
      </el-select>
      <span>Pesquisador: </span>
      <el-select v-model="userId" @change="$emit('userSelected', userId)" filterable class="select-primary el-select item" size="large" placeholder="Selecione um usuário" >
        <el-option value=""> Todos...</el-option>
        <el-option v-for="(val, index) in usersList" class="select-primary" :value="val._id" :label="val.name" :key="index" />
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'filter-map',
  props: {
    event: {
      default: ''
    },
    surveysList: {
      default: []
    },
    eventIdDefault: ''
  },
  data () {
    return {
      eventId: '',
      userId: ''
    }
  },
  mounted () {
    this.eventId = this.eventIdDefault
  },
  computed: {
    ...mapGetters('events', {
      events: 'optionsById'
    }),
    ...mapGetters('users', {
      users: 'usersIdName'
    }),
    usersList: function name () {
      const usersList = this.surveysList.reduce((acc, curr) => {
        if (!acc.hasOwnProperty(curr.user._id)) {
          acc[curr.user._id] = curr.user
        }
        return acc
      }, {})
      return Object.values(usersList)
    }
  },
  watch: {
    event: function () {

    }
  }
}
</script>

<style scoped>
  .box{
    padding:15px 15px 25px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/FiltersMap.vue